import {IObject3D} from '../Interfaces';
import {Selection} from './Selection';

declare let THREE: any;

export abstract class Selectable extends (THREE.Object3D as { new(): IObject3D; }) {

  readonly selection: Selection;
  private boundingBox = new THREE.Box3();

  constructor() {
    super();
    this.selection = new Selection();
    this.add(this.selection);
  }

  abstract getBoundingBoxObjects(): Array<any>;

  raycast(raycaster, result) {
    const bb = this.getBoundingBoxObjects().reduce((boundingBox, obj) =>
      boundingBox.union(this.boundingBox.setFromObject(obj)), new THREE.Box3());
    if (raycaster.ray.intersectsBox(bb)) {
      result.push({
        object: this
      });
    }
    return result;
  }

  highlight() {
    this.selection.show();
  }

  unhighlight() {
    this.selection.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Selectable.ts